import { useEffect, useState } from "react";

interface CropHealthResponse {
  // Define this properly once you see actual structure
  [key: string]: any;
}

interface UseCropHealthHook {
  data: CropHealthResponse | null;
  loading: boolean;
  error: string | null;
}

export const useCropHealthData = (): UseCropHealthHook => {
  const [data, setData] = useState<CropHealthResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCropHealth = async () => {
      try {
        const res = await fetch(
          "https://agrichikitsa.org/api/v1/userDashboard/crop-health/694fc104b2d7a0cf2d2ee5cc",
        );
        if (!res.ok) throw new Error("Failed to fetch crop health data");
        const json = await res.json();
        setData(json);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchCropHealth();
  }, []);

  return { data, loading, error };
};
